import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { getSlates } from '../services/games-service.service.api';
import type { Slate } from '../interfaces/slates.interface';

function useSlates(
  scheduleId?: string,
  options?: Omit<UseQueryOptions<Slate[]>, 'queryKey' | 'queryFn'>
) {
  // eslint-disable-next-line local-rules/require-query-stale-time
  return useQuery({
    ...options,
    queryKey: ['contestSlates', scheduleId],
    queryFn: () => getSlates(scheduleId),
    enabled: !!scheduleId && (options?.enabled ?? true),
  });
}

export default useSlates;
